const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';
const EDGE_FN_URL = `${SUPABASE_URL}/functions/v1/resend-email`;
const CS_EMAIL = 'cs@brl.global';

interface SendBLEmailParams {
  toEmail: string;
  shipmentRef: string;
  vessel?: string;
  portOfLoading?: string;
  portOfDischarge?: string;
  pdfBase64: string;
}

function buildHtml(shipmentRef: string, vessel?: string, portOfLoading?: string, portOfDischarge?: string): string {
  return `<!DOCTYPE html>
<html lang="en">
<head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0"></head>
<body style="margin:0;padding:0;background:#f5f7fa;font-family:Arial,Helvetica,sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background:#f5f7fa;padding:30px 0;">
    <tr><td align="center">
      <table width="600" cellpadding="0" cellspacing="0" style="background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
        <tr>
          <td style="background:#1a56db;padding:24px 32px;">
            <table width="100%" cellpadding="0" cellspacing="0"><tr>
              <td>
                <div style="color:#fff;font-size:22px;font-weight:700;letter-spacing:1px;">BRL GLOBAL</div>
                <div style="color:#93c5fd;font-size:12px;margin-top:2px;">House Bill of Lading</div>
              </td>
              <td align="right">
                <div style="background:rgba(255,255,255,0.15);border-radius:6px;padding:8px 16px;color:#fff;font-size:18px;font-weight:700;">${shipmentRef}</div>
              </td>
            </tr></table>
          </td>
        </tr>
        <tr><td style="padding:32px;">
          <p style="margin:0 0 16px;color:#374151;font-size:15px;">Dear Customer,</p>
          <p style="margin:0 0 24px;color:#374151;font-size:14px;line-height:1.6;">
            Please find attached the <strong>Draft Bill of Lading</strong> for the shipment referenced below.
            Kindly review and advise any corrections required at your earliest convenience.
          </p>
          <table width="100%" cellpadding="0" cellspacing="0" style="background:#eff6ff;border-left:4px solid #1a56db;border-radius:0 6px 6px 0;margin-bottom:24px;">
            <tr><td style="padding:16px 20px;">
              <table width="100%" cellpadding="4" cellspacing="0">
                <tr>
                  <td style="color:#6b7280;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;width:45%;">Shipment Reference</td>
                  <td style="color:#111827;font-size:13px;font-weight:700;">${shipmentRef}</td>
                </tr>
                ${vessel ? `<tr><td style="color:#6b7280;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Vessel</td><td style="color:#111827;font-size:13px;">${vessel}</td></tr>` : ''}
                ${portOfLoading ? `<tr><td style="color:#6b7280;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Port of Loading</td><td style="color:#111827;font-size:13px;">${portOfLoading}</td></tr>` : ''}
                ${portOfDischarge ? `<tr><td style="color:#6b7280;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.5px;">Port of Discharge</td><td style="color:#111827;font-size:13px;">${portOfDischarge}</td></tr>` : ''}
              </table>
            </td></tr>
          </table>
          <p style="margin:0 0 8px;color:#374151;font-size:14px;line-height:1.6;">
            For questions or amendments contact <a href="mailto:${CS_EMAIL}" style="color:#1a56db;text-decoration:none;font-weight:600;">${CS_EMAIL}</a>.
          </p>
          <p style="margin:24px 0 0;color:#374151;font-size:14px;">Best regards,<br>
            <strong style="color:#111827;">Customer Service Team</strong><br>
            <span style="color:#6b7280;font-size:13px;">BRL Global</span>
          </p>
        </td></tr>
        <tr>
          <td style="background:#f9fafb;border-top:1px solid #e5e7eb;padding:16px 32px;">
            <p style="margin:0;color:#9ca3af;font-size:11px;text-align:center;">
              This is an automated message. The attached draft is for review purposes only.
            </p>
          </td>
        </tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;
}

export async function sendBLDraftEmail(params: SendBLEmailParams): Promise<{ success: boolean; error?: string }> {
  const { toEmail, shipmentRef, vessel, portOfLoading, portOfDischarge, pdfBase64 } = params;

  try {
    const response = await fetch(EDGE_FN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({
        to: [toEmail, CS_EMAIL],
        subject: `Draft Bill of Lading — ${shipmentRef}`,
        html: buildHtml(shipmentRef, vessel, portOfLoading, portOfDischarge),
        attachments: [
          {
            filename: `BL_DRAFT_${shipmentRef}.pdf`,
            content: pdfBase64,
            content_type: 'application/pdf',
          },
        ],
      }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || (data as any).success === false) {
      return { success: false, error: (data as any).error || `HTTP ${response.status}` };
    }

    return { success: true };
  } catch (err: any) {
    return { success: false, error: err.message || 'Network error' };
  }
}
